import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { CiviliteTitles } from "@inspire/data/static/pedagogie";
var ProfProfileSchema = new SimpleSchema({
    title: {
        type: String,
        optional: true,
        allowedValues: Object.keys(CiviliteTitles)
    },
    hadInspirePresentation: {
        type: Boolean,
        optional: false,
        defaultValue: false
    },
    pedagogie_filiere_generale: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_technologique: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_professionnelle: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_techno_agro: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_filiere_pro_agro: {
        type: Boolean,
        defaultValue: false,
        optional: true
    },
    pedagogie_lyceeId: {
        type: String,
        optional: true
    },
    pedagogie_departement: {
        type: String,
        optional: true
    },
    pedagogie_pays: {
        type: String,
        optional: true
    },
    pedagogie_lyceeEtrangerName: {
        type: String,
        optional: true
    },
    pedagogie_niveaux: {
        type: Array,
        optional: true,
        minCount: 1
    },
    "pedagogie_niveaux.$": {
        type: String
    }
});
export { ProfProfileSchema };
